(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- toast + cart badge ---------- */
  var toastEl = document.getElementById('Toast'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  }
  function setBadge(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function formatMoney(cents) {
    var fmt = (window.SEIN && window.SEIN.moneyFormat) || 'Rs {{amount_no_decimals}}';
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toLocaleString('en-PK');
    var withDec = Number(amount).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec)
              .replace(/\{\{\s*amount\s*\}\}/, withDec);
  }

  /* ---------- AJAX add to cart ---------- */
  function addToCart(id, qty, name) {
    return fetch(window.SEIN.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
      .then(function () {
        return fetch(window.SEIN.cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setBadge(cart.item_count);
        toast((name || 'Item') + ' added to bag');
        document.dispatchEvent(new CustomEvent('sein:cart', { detail: cart }));
      })
      .catch(function (e) { toast((e && e.description) || 'Could not add to bag'); });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    var qtyInput = btn.closest('form') ? btn.closest('form').querySelector('[name="quantity"]') : null;
    var qty = qtyInput ? qtyInput.value : 1;
    var id = btn.dataset.add;
    var form = btn.closest('form[data-product-form]');
    if (form) { var sel = form.querySelector('[name="id"]'); if (sel) id = sel.value; }
    btn.disabled = true;
    addToCart(id, qty, btn.dataset.name).finally(function () { btn.disabled = false; });
  });

  /* product form submit (fallback for Enter key) */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = form.querySelector('[data-add]');
      if (btn) btn.click();
    });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.dataset.qty === 'minus' ? Math.max(parseInt(input.min, 10) || 0, v - 1) : v + 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant select -> price ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    var sel = form.querySelector('select[name="id"]');
    if (!sel) return;
    var data = form.dataset.variants ? JSON.parse(form.dataset.variants) : [];
    sel.addEventListener('change', function () {
      var v = data.find(function (x) { return String(x.id) === sel.value; });
      if (!v) return;
      var price = document.querySelector('[data-price]'), was = document.querySelector('[data-compare]'), btn = form.querySelector('[data-add]');
      if (price) price.textContent = formatMoney(v.price);
      if (was) { was.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; was.hidden = !(v.compare_at_price > v.price); }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : 'Sold out'; }
    });
  });

  /* ---------- announcement slider ---------- */
  document.querySelectorAll('.ticker:not(.single)').forEach(function (t) {
    var li = Array.prototype.slice.call(t.querySelectorAll('li')), i = 0, timer;
    if (li.length < 2) return;
    function go(n) {
      var cur = li[i];
      cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 500);
      i = (n + li.length) % li.length;
      li[i].classList.add('is-active');
    }
    function auto() { clearInterval(timer); if (!reduce) timer = setInterval(function () { go(i + 1); }, Number(t.dataset.interval) || 4000); }
    var n = t.querySelector('.next'), p = t.querySelector('.prev');
    if (n) n.addEventListener('click', function () { go(i + 1); auto(); });
    if (p) p.addEventListener('click', function () { go(i - 1); auto(); });
    auto();
  });

  /* ---------- hero slider ---------- */
  document.querySelectorAll('.hero:not(.single)').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.slide')),
        dots = Array.prototype.slice.call(hero.querySelectorAll('.dots button')), i = 0, timer;
    if (slides.length < 2) return;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function auto() { clearInterval(timer); if (!reduce && hero.dataset.autoplay !== 'false') timer = setInterval(function () { go(i + 1); }, Number(hero.dataset.interval) || 6000); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); auto(); }); });
    var nx = hero.querySelector('.arrows .next'), pv = hero.querySelector('.arrows .prev');
    if (nx) nx.addEventListener('click', function () { go(i + 1); auto(); });
    if (pv) pv.addEventListener('click', function () { go(i - 1); auto(); });
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', auto);
    auto();
  });

  /* ---------- mobile menu + search ---------- */
  var drawer = document.getElementById('MenuDrawer');
  document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.classList.add('is-open'); }); });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.classList.remove('is-open'); }); });
  var search = document.getElementById('SearchBar');
  document.querySelectorAll('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (!search) return;
      search.classList.toggle('is-open');
      if (search.classList.contains('is-open')) { var inp = search.querySelector('input'); inp && inp.focus(); }
    });
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-main-image]');
    g.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        main.style.opacity = 0;
        setTimeout(function () { main.src = b.dataset.thumb; main.srcset = b.dataset.srcset || ''; main.style.opacity = 1; }, 180);
      });
    });
  });

  /* ---------- cart page: quantity changes ---------- */
  document.querySelectorAll('[data-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      fetch(window.SEIN.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(input.dataset.lineQty), quantity: Number(input.value) })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); window.location.href = url.toString();
  });

  setBadge(window.SEIN ? window.SEIN.cartCount : 0);
})();


(function(){
  if(!('IntersectionObserver' in window))return;
  var sel='.sec-head,.card,.tile,.set,.rev,.proof .shot,.chip,.gift-card,.spot .item,.pair,.ugc a,.promises .wrap>div,.about blockquote,.about .figure,.news .wrap>*,.proof .dm,.campaign blockquote,.beliefs .grid>div,.future li,.prose,.story .figure';
  var els=document.querySelectorAll(sel);
  els.forEach(function(e,n){e.classList.add('rv');e._i=n});
  var o=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.style.transitionDelay=(en.target._i%4*90)+'ms';en.target.classList.add('in');o.unobserve(en.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  els.forEach(function(e){o.observe(e)});
  function sweep(){var vh=window.innerHeight;els.forEach(function(e){if(!e.classList.contains('in')){var r=e.getBoundingClientRect();if(r.top<vh&&r.bottom>0){e.classList.add('in');o.unobserve(e)}}})}
  window.addEventListener('scroll',sweep,{passive:true});window.addEventListener('hashchange',function(){setTimeout(sweep,50)});setTimeout(sweep,800);
})();


/* ---------- cart drawer ---------- */
(function(){
  var drawer=document.getElementById('CartDrawer'); if(!drawer) return;
  var body=document.getElementById('CartDrawerBody'), sub=document.getElementById('CartDrawerSub'), checkout=document.getElementById('CartCheckout');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function money(c){var fmt=(window.SEIN&&window.SEIN.moneyFormat)||'Rs {{amount_no_decimals}}';var noDec=Math.round(c/100).toLocaleString('en-PK');var withDec=Number((c/100).toFixed(2)).toLocaleString('en-PK',{minimumFractionDigits:2,maximumFractionDigits:2});return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/,noDec).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,withDec).replace(/\{\{\s*amount\s*\}\}/,withDec)}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function render(cart){
    if(!cart.items.length){body.innerHTML='<div class="empty">Your bag is empty.</div>'}
    else body.innerHTML=cart.items.map(function(it,i){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_160x200_crop_center$1$2'):'';
      var was=it.original_line_price>it.final_line_price?'<s>'+money(it.original_line_price)+'</s>':'';
      var variant=it.variant_title&&it.variant_title!=='Default Title'?' · '+esc(it.variant_title):'';
      return '<div class="cline" data-line="'+(i+1)+'">'+(img?'<img class="th" src="'+img+'" alt="">':'<div class="th"></div>')+'<div><div class="nm"><a href="'+it.url+'">'+esc(it.product_title)+'</a></div><div class="pr">'+money(it.final_line_price)+was+variant+'</div><div class="ctl"><div class="q"><button type="button" data-cq="-1" aria-label="Decrease">−</button><output>'+it.quantity+'</output><button type="button" data-cq="1" aria-label="Increase">+</button></div><a href="#" class="rm" data-crm>Remove</a></div></div></div>'}).join('');
    sub.textContent=money(cart.items_subtotal_price);
    document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;el.hidden=cart.item_count===0});
    var note=document.getElementById('CartNote'); if(note&&document.activeElement!==note) note.value=cart.note||'';
  }
  function load(){return fetch(window.SEIN.cartUrl+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){render(c);return c})}
  function open(){load().then(function(){drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('drawer-open')})}
  function close(){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('drawer-open')}
  window.seinCartOpen=open;
  document.querySelectorAll('a.bag,[data-cart-open]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();open()})});
  drawer.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',close)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  document.addEventListener('sein:cart',function(e){render(e.detail);if(window.SEIN.openDrawerOnAdd!==false){drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('drawer-open')}});
  function change(line,qty){return fetch(window.SEIN.cartChangeUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})}).then(function(r){return r.json()}).then(render)}
  body.addEventListener('click',function(e){
    var q=e.target.closest('[data-cq]'),rm=e.target.closest('[data-crm]'); if(!q&&!rm) return;
    e.preventDefault(); var row=e.target.closest('.cline'), line=Number(row.dataset.line), cur=Number(row.querySelector('output').textContent);
    change(line, rm?0:Math.max(0,cur+Number(q.dataset.cq)));
  });
  drawer.querySelectorAll('[data-cart-tool]').forEach(function(b){b.addEventListener('click',function(){
    var on=b.classList.contains('is-on');
    drawer.querySelectorAll('[data-cart-tool]').forEach(function(x){x.classList.remove('is-on')});
    drawer.querySelectorAll('[data-tool-panel]').forEach(function(p){p.hidden=true});
    if(!on){b.classList.add('is-on');drawer.querySelector('[data-tool-panel="'+b.dataset.cartTool+'"]').hidden=false}
  })});
  var noteBtn=drawer.querySelector('[data-note-save]'); if(noteBtn) noteBtn.addEventListener('click',function(){
    fetch(window.SEIN.cartUpdateUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:document.getElementById('CartNote').value})}).then(function(){noteBtn.textContent='Saved';setTimeout(function(){noteBtn.textContent='Save note'},1500)});
  });
  var cpBtn=drawer.querySelector('[data-coupon-apply]'); if(cpBtn) cpBtn.addEventListener('click',function(){
    var code=(document.getElementById('CartCoupon').value||'').trim(), msg=document.getElementById('CartCouponMsg');
    if(!code){msg.textContent='Enter a code first.';return}
    checkout.href='/discount/'+encodeURIComponent(code)+'?redirect=/checkout';
    msg.textContent='Code '+code+' will be applied at checkout.';
  });
})();
